import type { ComposerTranslation } from 'vue-i18n'

export const getTargetBlankLabel = (label: string, t: ComposerTranslation) => {
  return `${label} (${t('navigation.target_blank')})`
}
